import { graphqlApi } from '~/shared/store/api-services/graphql-api';
import { pagesInitialState } from '~/shared/store/slices/course-categories/course-categories-slice';
import {
  setPersonalLessonExercisesPagination,
  setSharedLessonExercisesPagination,
  setToDoLessonExercisesPagination,
} from '~/shared/store/slices/lesson-exercises/lesson-exercises-slice';
import {
  initialPageInfo,
  setIsLessonsPaginationReset,
  setLessonsPagination,
  setLessonTemplateLessonsPaginationReset,
  setZeroLesson,
} from '~/shared/store/slices/lessons/lessons-slice';
import type { CourseType } from '~/shared/types/course-type';
import type { UserType } from '~/shared/types/user-type';
import { USER_ROLE } from '~/universal/constants';

type ParticipantLike =
  | string
  | null
  | undefined
  | {
      _id?: unknown;
      id?: unknown;
      user?: unknown;
    };

const isNonEmptyString = (value: unknown): value is string => {
  return typeof value === 'string' && value.length > 0;
};

export const normalizeParticipants = (participants: ParticipantLike[]): string[] => {
  const normalized = participants
    .map((item): string | null => {
      if (!item) {
        return null;
      }

      if (typeof item === 'string') {
        return item;
      }

      if (typeof item === 'object') {
        if ('_id' in item && item._id) {
          return String(item._id);
        }

        if ('user' in item && item.user && typeof item.user === 'object' && '_id' in item.user && item.user._id) {
          return String(item.user._id);
        }

        if ('user' in item && item.user) {
          return String(item.user);
        }

        if ('id' in item && item.id) {
          return String(item.id);
        }
      }

      return null;
    })
    .filter(isNonEmptyString)
    .filter((item) => item !== '[object Object]')
    .sort();

  return Array.from(new Set(normalized));
};

export const checkIsEditableModule = ({ course, user }: { course: CourseType; user: UserType }) => {
  return (
    (course?.settings?.isEditableModuleForTeacher && user?.role === USER_ROLE.TEACHER) ||
    user?.role === USER_ROLE.SUPER_TEACHER
  );
};

export const resetLessonsList = (dispatch) => {
  dispatch(setZeroLesson(null));
  dispatch(setIsLessonsPaginationReset(true));
  dispatch(
    setLessonsPagination({
      isLoading: true,
      pageInfo: initialPageInfo,
      items: [],
    }),
  );
  dispatch(setLessonTemplateLessonsPaginationReset(true));
};

export const reloadExercises = (dispatch) => {
  dispatch(graphqlApi.util.invalidateTags(['lesson-exercises']));
  dispatch(
    setSharedLessonExercisesPagination({
      isLoading: true,
      items: [],
      pageInfo: pagesInitialState,
    }),
  );
  dispatch(
    setPersonalLessonExercisesPagination({
      isLoading: true,
      items: [],
      pageInfo: pagesInitialState,
    }),
  );
  dispatch(
    setToDoLessonExercisesPagination({
      isLoading: true,
      items: [],
      pageInfo: pagesInitialState,
    }),
  );
};
